import Vue from 'vue';
import { User } from '@/data/models/user.model';
import { Headquarter } from '@/data/models/headquarter.model';

export class State {

	/** Data */
	user?: User = undefined;
	headquarter?: Headquarter = undefined;

	headquarters: Headquarter[] = [];

	cachelists: { [key: string]: { [key: string]: string } } = {};

	reset() {
		this.user = undefined;
		this.headquarter = undefined;
		this.cachelists = {};
		this.headquarters = [];
	}
}

export default Vue.observable(new State());
